/**
 * 간편결제 계좌 정보조회 API 문서: https://alpha-send-api.pay.naver.com/send-api/docs/index.html#_%EA%B0%84%ED%8E%B8%EA%B3%84%EC%A2%8C_%EC%A1%B0%ED%9A%8C_api_newest
 */

import {BankCodeType, FinancialInvestmentCompanyCodeType} from '@web/core/constants'

type DateString = string

type TimeString = string

export type Account = {
    /** 계좌시퀀스 */
    acctKey: number
    /** 은행코드 */
    bnkCd: BankCodeType | FinancialInvestmentCompanyCodeType
    /** 은행명 */
    bnkNm: string
    bnkType: BankTypeType
    /** 마스킹된 계좌번호 */
    maskAcctNo: string
    /** 계좌번호 */
    acctNo: string
    /** 등록완료 시각 */
    regCmplTime: string
    /** 체크카드연결계좌여부 */
    isChkCard: boolean
    /** 별칭 */
    nickNm: Maybe<string>
    /** 노출순서 */
    rank: number
    /** 제휴통장상품코드 */
    payBnkbCd: Maybe<string>
    /** 제휴통장상품명 */
    payBnkbNm: Maybe<string>
    /** 결제가능여부 */
    isPayable: boolean
    /** 오픈뱅킹계좌여부 */
    isOpenBankAccount: boolean
    /** PL상환계좌여부 */
    isPlAccount: boolean
    /** 환불대표계좌여부 */
    isRefundAccount: boolean
    /** AML이행여부 */
    isCmplAml: boolean
    /** 대기결제가능여부 */
    isPendingPayable: boolean
    /** 점검내역 */
    inspection: Maybe<{
        /** 점검시작날짜 YYYY-MM-DD */
        startDate: DateString
        /** 점검시작시간 HH:MM */
        startTime: TimeString
        /** 점검종료날짜 YYYY-MM-DD */
        endDate: DateString
        /** 점검종료시간 HH:MM */
        endTime: TimeString
        /** 점검메시지 */
        message: string
    }>
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const BankType = {
    BANK: 'bank',
    STOCK: 'stock',
} as const

export type BankTypeType = Constant<typeof BankType>

export const ResultCode = {
    /** 성공 */
    SUCCEED: '1000',
    /** 파라메터 누락 */
    PARAMETER_OMITTED: '2000',
    /** 파라메터 형식 오류 */
    PARAMETER_FORM_ERROR: '2001',
    /** 등록된 계좌 없음 */
    NO_ACCOUNTS: '3001',
    /** 은행 전체 점검 */
    INSPECTION: '3106',
    /** 공동망 점검 */
    COMMON_NETWORK_INSPECTION: '3091',
    /** 시스템 오류 */
    SYSTEM_ERROR: '4000',
} as const

export type ResultCodeType = Constant<typeof ResultCode>

export type EasyAccountsResult = {
    acctList: Account[]
    isAgreedOpenBank: boolean
    resultCode: ResultCodeType
    resultMessage: string
}
